/** IDs das operações de venda que identifica cada operação de venda */
export enum OperacaoVendaID {
    NORMAL = 1,
    DECORRENTE_CONSIGNACAO = 2,
    ENTREGA_FUTURA = 3
}

export namespace OperacaoVendaID {
    /** Verifica se é a operação de venda Normal */
    export function isNormal(id: number): boolean {
        return id == OperacaoVendaID.NORMAL;
    }

    /** Verifica se é a operação de venda Decorrente de Consignação */
    export function isDecorrenteConsignation(id: number): boolean {
        return id == OperacaoVendaID.DECORRENTE_CONSIGNACAO;
    }

    /** Verifica se é a operação de venda Entrega Futura */
    export function isEntregaFutura(id: number): boolean {
        return id == OperacaoVendaID.ENTREGA_FUTURA;
    }
}

/** Representa uma Operação de Venda */
export interface OperacaoVenda {
    id: OperacaoVendaID;
    nome: string;
    descricao: string;
}

export namespace OperacaoVenda {
    /** Operação de Venda Normal */
    export const NORMAL: OperacaoVenda = {
        id: OperacaoVendaID.NORMAL,
        nome: 'Normal',
        descricao: 'Venda normal'
    };

    /** Operação de Venda Decorrente de Consignação */
    export const DECORRENTE_CONSIGNACAO: OperacaoVenda = {
        id: OperacaoVendaID.DECORRENTE_CONSIGNACAO,
        nome: 'Decorrente de Consignação',
        descricao: 'Venda decorrente de consignação'
    };

    /** Operação de Venda Entrega Futura */
    export const ENTREGA_FUTURA: OperacaoVenda = {
        id: OperacaoVendaID.ENTREGA_FUTURA,
        nome: 'Entrega Futura',
        descricao: 'Venda com entrega futura'
    };

    /** Retorna todas as operações de venda */
    export function getAll(): OperacaoVenda[] {
        return [
            NORMAL,
            DECORRENTE_CONSIGNACAO,
            ENTREGA_FUTURA
        ];
    }

    /** Obtém a operação de venda pelo id */
    export function getById(id: number): OperacaoVenda | undefined {
        return getAll().find(operacao => operacao.id === id);
    }
}
